import React, {Component} from 'react';
import {compose} from "redux";
import {firestoreConnect, withFirestore} from "react-redux-firebase";
import {connect} from "react-redux";
import {UserIsAuthenticated} from "../../utils/AuthManager";
import {withRouter} from 'react-router-dom'
import {StyledButton, StyledButtonRed} from "../../components/Buttons";
import {SUBSCRIBED} from "../../utils/subsciptionStatus";
import {COMPANY_DB_PATH} from "../../constants/DB_PATHS";
import {BackgroundDiv} from "../../components/Containers";
import Navbar from "../../components/Navbar";
import {
    COMPANY_CALLS_URL, COMPANY_SERVICE_PRICES_URL,
    COMPANY_SETTINGS_URL,
    EMPLOYEE_REQUESTS_URL,
    EMPLOYEE_SETTINGS_URL, PROFILE_SETTINGS_URL
} from "../../constants/URLS";
import {ACCEPTED} from "../../utils/employeeStatus";


class Profile extends Component {
    render() {





        console.log(this.props)
        const {profile, auth, myCompany} = this.props
        return (
            <div>
                <BackgroundDiv/>
                <h2>Profile</h2>
                <div><span>Display name: </span>{auth.displayName}</div>
                <div><span>Status: </span>{profile.role}</div>

                {profile && profile.role === 'company' ?
                    <div>
                        <div><span>CompanyId: </span>{profile.companyId}</div>
                        <div><span>Company Name: </span>{myCompany && myCompany[0] ?
                            myCompany[0].companyName : null}</div>
                    </div>
                    :
                    <div>
                        <div><span>My status: </span>{profile.employeeStatus}</div>
                        {profile.employeeStatus === ACCEPTED ?
                            <div>
                                <div><span>CompanyId: </span>{profile.companyId}</div>
                                <div><span>Company Name: </span>{myCompany && myCompany[0] ?
                                    myCompany[0].companyName : null}</div>
                            </div>
                            :
                            <div>

                            </div>
                        }


                    </div>
                }


                <StyledButtonRed onClick={() => {
                    this.props.firebase.logout()
                }}>Logout
                </StyledButtonRed>

                <StyledButton onClick={() => {
                    this.props.history.push('/calls/exclusive')
                }}>
                    Exclusive calls</StyledButton>

                <StyledButton onClick={() => {
                    this.props.history.push(PROFILE_SETTINGS_URL)
                }}>
                    Profile settings</StyledButton>

                {profile && profile.role === 'company' ?
                    <div>
                        <StyledButton onClick={() => {
                            this.props.history.push(EMPLOYEE_REQUESTS_URL)
                        }}>Employee request</StyledButton>
                        <StyledButton onClick={() => {
                            this.props.history.push(COMPANY_SETTINGS_URL)
                        }}>Company-settings</StyledButton>
                        <StyledButton onClick={() => {
                            this.props.history.push(COMPANY_SERVICE_PRICES_URL)
                        }}>Service Prices</StyledButton>
                        <StyledButton onClick={() => {
                            this.props.history.push(COMPANY_CALLS_URL)
                        }}>Company calls</StyledButton>
                    </div>
                    :
                    <div>
                        <StyledButton onClick={() => {
                            this.props.history.push(EMPLOYEE_SETTINGS_URL)
                        }}>Employee settings</StyledButton>
                    </div>
                }
            </div>
        );
    }
}

export default compose(
    withRouter,
    withFirestore,
    UserIsAuthenticated,
    connect(
        ({firebase: {auth, profile}}) => ({
            auth,
            profile
        })
    ),
    connect((state, props) => ({
        myCompany: state.firestore.ordered[COMPANY_DB_PATH],
    })),
    firestoreConnect(props => {
            return [
                {
                    collection: COMPANY_DB_PATH,
                    doc: props.profile.companyId || ''
                },
            ]
        }
    ),
)(Profile);